import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { UntypedFormArray, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-calendario-importar-emparejar',
  standalone: false,
  templateUrl: './calendario-importar-emparejar.component.html',
  styleUrls: ['../calendario.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CalendarioImportarEmparejarComponent implements OnInit {

  @Input()
  form: UntypedFormArray;
  @Input()
  propiedad: string;
  @Input()
  aEmparejar: string;
  @Input()
  objetos: any[];
  @Input()
  opciones$: Observable<any>[];


  constructor() { }

  ngOnInit(): void {
    this.objetos = this.objetos.sort((a, b) => a.position - b.position);
  }

  change(value, index) {
    this.form.at(index).setValidators(value ? [Validators.required] : []);
  }

}
